














































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { UserService, RegisterUserData } from '@/api'

@Component({})
export default class Register extends Vue {
  registerDone = false
  req: RegisterUserData = {
    email: '',
    password: '',
    name1: '',
    name2: '',
    name3: '',
    pay: '',
    economics: false,
    juridas: false,
    humanitary: false,
    technology: false,
    languages: false,
    key: ''
  }

  password = ''

  register (): void {
    if (this.req === undefined) {
      return
    }

    UserService.registerUser({ requestBody: this.req }).then(resp => {
      if (this.req.password !== this.password) {
        return
      }

      if (resp.registered) {
        this.registerDone = true
      }
    })
  }
}
